var MyAllhomesEmailPreferences = {
  ANNOUNCEMENTS: {
    code: 1,
    description: 'Allhomes Announcements'
  },
  NEWSLETTERS: {
    code: 2,
    description: 'Allhomes Newsletter',
    article: 'the'
  },
  THIRD_PARTY: {
    code: 4,
    description: 'Allhomes Partner Communications'
  },
  CANBERRA_AUCTION_RESULTS: {
    code: 8,
    description: 'Allhomes Canberra Auction Results Newsletter',
    article: 'the'
  },
  MY_FOLLOWED_PROPERTIES: {
    code: 16,
    description: 'My following properties will help you keep your finger on the property pulse with regular updates via email every month.'
  }
};
export default MyAllhomesEmailPreferences;